module.exports = __webpack_public_path__ + "img/viusalize.9665f2cd.jpg";